// World scale -----------------------------------------------------------------
/** Edge length of one world voxel in meters. */
export const VOXEL_SIZE = 0.1;
export const VOXELS_PER_METER = 10;

export const CHUNK_BITS = 5;
export const CHUNK_SIZE = 32;
export const CHUNK_MASK = 31;
export const CHUNK_AREA = CHUNK_SIZE * CHUNK_SIZE;
export const CHUNK_VOLUME = CHUNK_SIZE * CHUNK_SIZE * CHUNK_SIZE;

/** Edge length of one character voxel in meters (characters are twice as fine as the world). */
export const CHAR_VOXEL_SIZE = 0.05;

/** Palette index reserved for empty space. */
export const AIR = 0;
/** Palette index reserved for indestructible bedrock (map floor / boundary). */
export const BEDROCK = 1;
/** Pseudo-value the mesher sees outside the map: hides faces but casts no ambient occlusion. */
export const MESH_BOUNDARY = 255;

// Simulation ------------------------------------------------------------------
export const TICK_RATE = 30;
export const TICK_DT = 1 / TICK_RATE;
/** Player movement is simulated at a fixed 60 Hz on both client and server. */
export const MOVE_HZ = 60;
export const MOVE_DT = 1 / MOVE_HZ;
/** Movement steps processed per server tick. */
export const MOVES_PER_TICK = MOVE_HZ / TICK_RATE;

export const MAX_PLAYERS = 32;
export const PROTOCOL_VERSION = 6;

// Player body -----------------------------------------------------------------
export const PLAYER_HALF_WIDTH = 0.3;
export const PLAYER_HEIGHT = 1.7;
export const PLAYER_EYE_HEIGHT = 1.5;
export const STEP_HEIGHT = 0.55;

export const MOVE_SPEED = 6.2;
export const GROUND_ACCEL = 70;
export const AIR_ACCEL = 14;
export const GRAVITY = 22;
export const JUMP_VELOCITY = 7.6;
export const TERMINAL_VELOCITY = 45;
/** Max fall speed while gliding (Battle Royale drop). */
export const GLIDE_FALL_SPEED = 6.5;

export const BASE_HP = 100;
export const BASE_ARMOR = 60;
export const RESPAWN_TIME = 3;
export const SPAWN_PROTECTION = 2;

// Collapse ----------------------------------------------------------------------
/** Detached islands smaller than this crumble into debris instead of falling. */
export const CRUMBLE_THRESHOLD = 180;
/** Searches that visit more voxels than this are assumed to be supported. */
export const MAX_ISLAND_VOXELS = 60000;
